// import React, { useState, useRef, useEffect } from "react";
// import { FaFilter, FaSortAlphaDown, FaSortAlphaDownAlt } from "react-icons/fa";

// const ExcelLikeFilter = ({ column, data, onFilter }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedValues, setSelectedValues] = useState(new Set());
//   const dropdownRef = useRef(null);

//   // Get unique values for the column
//   const uniqueValues = [
//     ...new Set(data.map((row) => row[column] || "")),
//   ].sort();

//   useEffect(() => {
//     setSelectedValues(new Set(uniqueValues));
//   }, [data]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSort = (direction) => {
//     onFilter(column, "sort", direction);
//     setIsOpen(false);
//   };

//   const handleFilterChange = () => {
//     onFilter(column, "filter", Array.from(selectedValues));
//     setIsOpen(false);
//   };

//   const handleSelectAll = (checked) => {
//     setSelectedValues(checked ? new Set(uniqueValues) : new Set());
//   };

//   const handleValueToggle = (value) => {
//     const newSelected = new Set(selectedValues);
//     if (newSelected.has(value)) {
//       newSelected.delete(value);
//     } else {
//       newSelected.add(value);
//     }
//     setSelectedValues(newSelected);
//   };

//   return (
//     <div className="relative" ref={dropdownRef}>
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="p-1 hover:bg-gray-100 rounded"
//         title="Filter"
//       >
//         <FaFilter
//           className={`text-gray-500 ${
//             isOpen || selectedValues.size !== uniqueValues.length
//               ? "text-blue-500"
//               : ""
//           }`}
//         />
//       </button>

//       {isOpen && (
//         <div className="absolute z-50 top-full right-0 mt-1 w-64 bg-white border rounded-lg shadow-lg">
//           {/* Sort Options */}
//           <div className="p-2 border-b">
//             <div className="flex gap-2 mb-2">
//               <button
//                 onClick={() => handleSort("asc")}
//                 className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded w-full"
//                 title="Sort A to Z"
//               >
//                 <FaSortAlphaDown />
//                 <span>Sort A to Z</span>
//               </button>
//             </div>
//             <div className="flex gap-2">
//               <button
//                 onClick={() => handleSort("desc")}
//                 className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded w-full"
//                 title="Sort Z to A"
//               >
//                 <FaSortAlphaDownAlt />
//                 <span>Sort Z to A</span>
//               </button>
//             </div>
//           </div>

//           {/* Search Box */}
//           <div className="p-2 border-b">
//             <input
//               type="text"
//               placeholder="Search..."
//               className="w-full p-2 border rounded"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </div>

//           {/* Select All Option */}
//           <div className="p-2 border-b">
//             <label className="flex items-center gap-2">
//               <input
//                 type="checkbox"
//                 checked={selectedValues.size === uniqueValues.length}
//                 onChange={(e) => handleSelectAll(e.target.checked)}
//                 className="form-checkbox"
//               />
//               <span>(Select All)</span>
//             </label>
//           </div>

//           {/* Values List */}
//           <div className="max-h-60 overflow-y-auto p-2">
//             {uniqueValues
//               .filter((value) =>
//                 value
//                   .toString()
//                   .toLowerCase()
//                   .includes(searchTerm.toLowerCase())
//               )
//               .map((value, index) => (
//                 <label key={index} className="flex items-center gap-2 py-1">
//                   <input
//                     type="checkbox"
//                     checked={selectedValues.has(value)}
//                     onChange={() => handleValueToggle(value)}
//                     className="form-checkbox"
//                   />
//                   <span>{value || "(Blank)"}</span>
//                 </label>
//               ))}
//           </div>

//           {/* Action Buttons */}
//           <div className="p-2 border-t flex justify-end gap-2">
//             <button
//               onClick={handleFilterChange}
//               className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
//             >
//               OK
//             </button>
//             <button
//               onClick={() => setIsOpen(false)}
//               className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ExcelLikeFilter;

import React, { useState, useRef, useEffect } from "react";
import { FaFilter, FaSortAlphaDown, FaSortAlphaDownAlt } from "react-icons/fa";

const ExcelLikeFilter = ({ column, data, onFilter }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedValues, setSelectedValues] = useState(new Set());
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  // Get unique values for the column
  const uniqueValues = [
    ...new Set(data.map((row) => row[column] || "")),
  ].sort();

  useEffect(() => {
    setSelectedValues(new Set(uniqueValues));
  }, [data]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSort = (direction) => {
    onFilter(column, "sort", direction);
    setIsOpen(false);
  };

  const handleFilterChange = () => {
    onFilter(column, "filter", Array.from(selectedValues));
    setIsOpen(false);
  };

  const handleSelectAll = (checked) => {
    setSelectedValues(checked ? new Set(uniqueValues) : new Set());
  };

  const handleValueToggle = (value) => {
    const newSelected = new Set(selectedValues);
    if (newSelected.has(value)) {
      newSelected.delete(value);
    } else {
      newSelected.add(value);
    }
    setSelectedValues(newSelected);
  };

  return (
    <div className="relative inline-block">
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className="p-1 hover:bg-gray-100 rounded flex items-center justify-center"
        title="Filter"
      >
        <FaFilter
          className={`text-gray-500 w-4 h-4 ${
            isOpen || selectedValues.size !== uniqueValues.length
              ? "text-blue-500"
              : ""
          }`}
        />
      </button>

      {isOpen && (
        <div
          ref={dropdownRef}
          className="fixed z-50 bg-white border rounded-lg shadow-lg w-64"
          style={{
            // Dynamically position the dropdown
            top: buttonRef.current
              ? buttonRef.current.getBoundingClientRect().bottom + 5
              : "auto",
            left: buttonRef.current
              ? buttonRef.current.getBoundingClientRect().left
              : "auto",
          }}
        >
          {/* Sort Options */}
          <div className="p-2 border-b">
            <div className="flex gap-2 mb-2">
              <button
                onClick={() => handleSort("asc")}
                className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded w-full"
                title="Sort A to Z"
              >
                <FaSortAlphaDown />
                <span>Sort A to Z</span>
              </button>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => handleSort("desc")}
                className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded w-full"
                title="Sort Z to A"
              >
                <FaSortAlphaDownAlt />
                <span>Sort Z to A</span>
              </button>
            </div>
          </div>

          {/* Search Box */}
          <div className="p-2 border-b">
            <input
              type="text"
              placeholder="Search..."
              className="w-full p-2 border rounded"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          {/* Select All Option */}
          <div className="p-2 border-b">
            <label className="flex items-center gap-2">
              <input
                type="checkbox"
                checked={selectedValues.size === uniqueValues.length}
                onChange={(e) => handleSelectAll(e.target.checked)}
                className="form-checkbox"
              />
              <span>(Select All)</span>
            </label>
          </div>

          {/* Values List */}
          <div className="max-h-60 overflow-y-auto p-2">
            {uniqueValues
              .filter((value) =>
                value
                  .toString()
                  .toLowerCase()
                  .includes(searchTerm.toLowerCase())
              )
              .map((value, index) => (
                <label key={index} className="flex items-center gap-2 py-1">
                  <input
                    type="checkbox"
                    checked={selectedValues.has(value)}
                    onChange={() => handleValueToggle(value)}
                    className="form-checkbox"
                  />
                  <span>{value || "(Blank)"}</span>
                </label>
              ))}
          </div>

          {/* Action Buttons */}
          <div className="p-2 border-t flex justify-end gap-2">
            <button
              onClick={handleFilterChange}
              className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              OK
            </button>
            <button
              onClick={() => setIsOpen(false)}
              className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExcelLikeFilter;
